import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetDashboardV2Response } from './get-dashboard-v2-response';
import { getDashboardV2ResponseSchema } from './get-dashboard-v2-response';

export async function getDashboardV2Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetDashboardV2Response>> {
  return getRequest<IGetDashboardV2Response>({
    path: '/progress/v2/dashboard',
    schema: getDashboardV2ResponseSchema,
    options,
  });
}
